module.exports = __webpack_public_path__ + "static/3-af58093719773a6d8878533b8dd5c5c6.jpg";